import React, { createContext, useState } from "react";
import { nonEmpty, validateMobileNumber } from "../../utils/service";
import { useNavigate, useLocation } from "react-router-dom";
import RouteConstants from "../../constants/routesContent.json";
import {
  createVisitor,
  editVisitor,
  getCategoryList,
  getVisitorTypeList,
  magneticListApi,
} from "../../api/Api";
import { useEffect } from "react";
import { faL } from "@fortawesome/free-solid-svg-icons";

export const GuestRegisterContext = createContext({});
export const GuestRegisterContextProvider = ({ children }) => {
  const locationState = useLocation();
  const visitorInfo = locationState?.state?.visitorInfo;

  const [displayName, setDisplayName] = useState(
    visitorInfo ? visitorInfo.VisitorName : null
  );
  const isEdit = locationState?.state?.isEdit;
  const visitorId = locationState?.state?.visitorId;
  const VisitorName =
    visitorInfo && visitorInfo?.VisitorName ? visitorInfo?.VisitorName : "";
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [visitorTypeList, setVisitorTypeList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [visitorTypeDropdown, setVisitorTypeDropdown] = useState("Select");
  const [magneticId, setMagneticId] = useState(
    visitorInfo && visitorInfo?.MagneticId ? visitorInfo?.MagneticId : ""
  );
  const [guestNameRequired, setGuestNameRequired] = useState(true);
  const [contactNoRequired, setContactNoRequired] = useState(true);
  const [categoryRequired, setCategoryRequired] = useState(false);
  const [emergencyContactNoRequired, setEmergencyContactNoRequired] =
    useState(true);
  const [purposeOfVisitRequired, setPurposeOfVisitRequired] = useState(true);
  const [locationRequired, setLocationRequired] = useState(true);
  const [companyRequired, setCompanyRequired] = useState(true);
  const [vehicleNoRequired, setVehicleNoRequired] = useState(true);
  const [fromPlaceRequired, setFromPlaceRequired] = useState(true);
  const [visitorTypeRequired, setVisitorTypeRequired] = useState(false);
  const [guestPhotoRequired, setGuestPhotoRequired] = useState(true);
  const [guestListRequired, setGuesListRequired] = useState(true);
  const [magneticCardList, setMagneticCardList] = useState([]);
  const [magneticCardCode, setMagneticCardCode] = useState([]);
  const [visitorSpinnerStatus, setVisitorSpinnerStatus] = useState(false);
  const [guestType, setGuestType] = useState(
    visitorInfo && visitorInfo?.Type ? visitorInfo?.Type : "I"
  );

  const changeable = visitorInfo?.Type;

  const [guestPhoto, setGuestPhoto] = useState(
    visitorInfo && visitorInfo?.ImagePath ? visitorInfo?.ImagePath : ""
  );

  const [guestList, setGuestList] = useState(
    visitorInfo && visitorInfo?.CoPassengerFileName
      ? visitorInfo?.CoPassengerFileName
      : ""
  );
  const [pdfFileLabel, setPdfFileLabel] = useState(
    visitorInfo && visitorInfo?.idProof ? visitorInfo?.idProof : ""
  );

  const [idProof, setIdProof] = useState(
    visitorInfo && visitorInfo?.idProof ? visitorInfo?.idProof : ""
  );
  const [photoLabel, setPhotoLabel] = useState(
    visitorInfo && visitorInfo.ImagePath ? visitorInfo.ImagePath : ""
  );
  const [cameraLabel, setCameraLabel] = useState(
    visitorInfo && visitorInfo.ImagePath ? visitorInfo.ImagePath : ""
  );
  const [guestName, setGuestName] = useState(
    visitorInfo && visitorInfo?.VisitorName ? visitorInfo?.VisitorName : ""
  );
  const [contactNo, setContactNo] = useState(
    visitorInfo && visitorInfo?.VisitorPhoneNo
      ? visitorInfo?.VisitorPhoneNo
      : ""
  );
  const [category, setCategory] = useState({});
  const [emergencyContactNo, setEmergencyContactNo] = useState(
    visitorInfo && visitorInfo?.EmergencyNo ? visitorInfo?.EmergencyNo : ""
  );
  const [purposeOfVisit, setPurposeOfVisit] = useState(
    visitorInfo && visitorInfo?.PurposeOfVisit
      ? visitorInfo?.PurposeOfVisit
      : ""
  );
  const [location, setLocation] = useState(
    visitorInfo && visitorInfo?.LocationOfVisit
      ? visitorInfo?.LocationOfVisit
      : ""
  );
  const [company, setCompany] = useState(
    visitorInfo && visitorInfo?.VisitorCompany
      ? visitorInfo?.VisitorCompany
      : ""
  );
  const [vehicleNo, setVehicleNo] = useState(
    visitorInfo && visitorInfo?.VehicleNo ? visitorInfo?.VehicleNo : ""
  );
  const [fromPlace, setFromPlace] = useState(
    visitorInfo && visitorInfo?.VisitorLocation
      ? visitorInfo?.VisitorLocation
      : ""
  );
  const [visitorType, setVisitorType] = useState(
    visitorInfo && visitorInfo?.VisitorType
      ? visitorInfo?.VisitorType
      : "Select"
  );
  const [isCamera, setIsCamera] = useState(false);
  const [modalOpenStatus, setModalOpenStatus] = useState(false);
  const [show, setShow] = useState(false);
  const [assignedTo, setAssignedTo] = useState(
    visitorInfo && visitorInfo?.assignedTo ? visitorInfo?.assignedTo : ""
  );
  const [inavalidIdProof, setInavalidIdProof] = useState(true);
  const [magneticCardIdRequired, setMagneticCardIdRequired] = useState(false);
  const [idORPhotoOptional, setIdORPhotoOptional] = useState(true);
  const [statusCode, setStatusCode] = useState(0);

  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };

  const goBack = () => {
    navigate(RouteConstants.VISITORS_MAPPING);
    // navigate(-1);
  };

  const resetFields = (prevTab) => {
    setGuestName("");
    setEmergencyContactNo("");
    setCompany("");
    setMagneticId("");
    setVisitorType("Select");
    setContactNo("");
    setPurposeOfVisit("");
    setVehicleNo("");
    setAssignedTo("");
    setLocation("");
    setFromPlace("");
    setGuestList("");
    setGuestPhoto("");
    setPhotoLabel("");
    setPdfFileLabel("PNG, JPEG, PDF Format");
    setIdProof("");
  };

  const setIndividual = () => {
    guestType === "G" && resetFields(guestType);
    setGuestType("I");
  };

  const setGuest = () => {
    guestType === "I" && resetFields(guestType);
    setGuestType("G");
  };

  const guestNameValidationCheck = () => {
    if (nonEmpty(guestName)) {
      setGuestNameRequired(true);
      return true;
    } else {
      setGuestNameRequired(false);
      return false;
    }
  };

  const emergencyNumberValidationCheck = () => {
    if (
      nonEmpty(emergencyContactNo.toString()) &&
      validateMobileNumber(emergencyContactNo)
    ) {
      setEmergencyContactNoRequired(true);
      return true;
    } else {
      setEmergencyContactNoRequired(false);
      return false;
    }
  };

  const contactNumberValidationCheck = () => {
    if (nonEmpty(contactNo.toString()) && validateMobileNumber(contactNo)) {
      setContactNoRequired(true);
      return true;
    } else {
      setContactNoRequired(false);
      return false;
    }
  };

  const categoryValidationCheck = () => {
    if (nonEmpty(category) && category != "Select") {
      setCategoryRequired(false);
      return true;
    } else {
      setCategoryRequired(true);
      return false;
    }
  };

  const visitPurposeValidationCheck = () => {
    if (nonEmpty(purposeOfVisit)) {
      setPurposeOfVisitRequired(true);
      return true;
    } else {
      setPurposeOfVisitRequired(false);
      return false;
    }
  };

  const locationValidationCheck = () => {
    if (nonEmpty(location)) {
      setLocationRequired(true);
      return true;
    } else {
      setLocationRequired(false);
      return false;
    }
  };

  const companyValidationCheck = () => {
    if (nonEmpty(company)) {
      setCompanyRequired(true);
      return true;
    } else {
      setCompanyRequired(false);
      return false;
    }
  };

  const magneticCardValidationCheck = () => {
    if (!nonEmpty(magneticId)) {
      setMagneticCardIdRequired(true);
      return false;
    } else {
      setMagneticCardIdRequired(false);
      return true;
    }
  };

  const vehicleValidationCheck = () => {
    if (nonEmpty(vehicleNo)) {
      setVehicleNoRequired(true);
      return true;
    } else {
      setVehicleNoRequired(false);
      return false;
    }
  };

  //

  const fromPlaceValidationCheck = () => {
    if (nonEmpty(fromPlace)) {
      setFromPlaceRequired(true);
      return true;
    } else {
      setFromPlaceRequired(false);
      return false;
    }
  };

  const visitorTypeValidationCheck = () => {
    if (nonEmpty(visitorType) && visitorType != "Select") {
      setVisitorTypeRequired(false);
      return true;
    } else {
      setVisitorTypeRequired(true);
      return false;
    }
  };

  const guestListValidationCheck = () => {
    if (guestType == "G") {
      if (nonEmpty(guestList)) {
        setGuesListRequired(true);
        return true;
      } else {
        setGuesListRequired(false);
        return false;
      }
    } else {
      return true;
    }
  };

  const addPhotoValidationCheck = () => {
    if (nonEmpty(photoLabel) || nonEmpty(pdfFileLabel)) {
      // setGuestPhotoRequired(true);
      setInavalidIdProof(true);
      return true;
    } else {
      setInavalidIdProof(false);
      //  setGuestPhotoRequired(false);
      return false;
    }
  };

  const idProofValidatonCheck = () => {
    if (nonEmpty(pdfFileLabel)) {
      setInavalidIdProof(true);

      return true;
    } else {
      setInavalidIdProof(false);
      return false;
    }
  };
  const callCategoryList = async () => {
    try {
      const getData = await getCategoryList();
      if (getData.data.status === 200) {
        const categoryItems = getData.data.data.categories;
        setCategoryList(categoryItems);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  const callVisitorTypeList = async () => {
    try {
      const getData = await getVisitorTypeList();
      if (getData.data.status === 200) {
        const visitorTypesitems = getData.data.data?.visitorTypes;
        setVisitorTypeList(visitorTypesitems);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  useEffect(() => {
    callCategoryList();
    callVisitorTypeList();
  }, []);

  const magneticListData = async (listSearch) => {
    try {
      const response = await magneticListApi(listSearch);
      if (response?.data?.status === 200) {
        setMagneticCardList(response?.data?.data?.cards);
        const cardCodeList = response?.data?.data?.cards?.map((item) => {
          return item?.MagneticId;
        });
        setMagneticCardCode(cardCodeList);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  const alertBack = () => {
    navigate(RouteConstants.VISITORS_MAPPING);
    setShowAlert(false);
  };

  useEffect(() => {
    const visitorDetailData = magneticCardList.filter((item) => {
      return item?.MagneticId === magneticId;
    });
  }, [magneticId, magneticCardList]);

  useEffect(() => {
    let visitorTypeReceivedFromSavedData;
    if (visitorTypeList.length > 0 && visitorType != "Select") {
      visitorTypeReceivedFromSavedData = visitorTypeList.filter((item) => {
        return item.name === visitorType;
      });
      setVisitorType(...visitorTypeReceivedFromSavedData);
    }
  }, [visitorTypeList]);

  useEffect(() => {
    getCategory();
  }, [categoryList]);
  const getCategory = () => {
    const result = categoryList.filter((item) => {
      if (item?.id == 6) {
        setCategory({ id: item?.id, name: item?.name });
      }
    });
  };

  const getVisitorData = () => {
    let formData = new FormData();
    formData.append("Type", guestType);
    formData.append("VisitorName", guestName);
    formData.append("VisitorPhoneNo", contactNo);
    formData.append("Category", category?.id);
    formData.append("AssignedTo", assignedTo);
    formData.append("EmergencyNo", emergencyContactNo);
    formData.append("PurposeOfVisit", purposeOfVisit);
    formData.append("LocationOfVisit", location);
    formData.append("VisitorCompany", company);
    formData.append("VehicleNo", vehicleNo);
    formData.append("VisitorPlace", fromPlace); //in save VisitorPlace
    formData.append("VisitorType", visitorType?.name);
    formData.append("MagneticId", magneticId);
    formData.append("VisitorPhoto", guestPhoto);
    formData.append("coPassengerList", guestList);
    formData.append("idProof", idProof);

    return formData;
  };

  const editvistorData = () => {
    let formData = new FormData();
    formData.append("VisitorName", guestName);
    formData.append("VisitorPhoneNo", contactNo);
    formData.append("Category", category?.id);
    formData.append("AssignedTo", assignedTo);
    formData.append("EmergencyNo", emergencyContactNo);
    formData.append("PurposeOfVisit", purposeOfVisit);
    formData.append("LocationOfVisit", location);
    formData.append("VisitorCompany", company);
    formData.append("VehicleNo", vehicleNo);
    formData.append("VisitorLocation", fromPlace); //in save VisitorPlace
    formData.append("VisitorType", visitorType?.name);
    formData.append("MagneticId", magneticId);
    formData.append("VisitorPhoto", guestPhoto);
    formData.append("idProof", idProof);
    return formData;
  };
  const callVisitorRegistration = async () => {
    setVisitorSpinnerStatus(true);
    try {
      const getData = await createVisitor(getVisitorData());
      if (getData.data.status === 200) {
        setVisitorSpinnerStatus(false);
        setShowAlert(true);
        setAlertMessage(getData?.data?.message);
        //navigate(RouteConstants.VISITORS_MAPPING);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  const callEditVisitorApi = async (visitorId) => {
    setVisitorSpinnerStatus(true);
    try {
      const getData = await editVisitor(editvistorData(), visitorId);

      if (getData?.data?.status === 201 || getData?.data?.status === 200) {
        setVisitorSpinnerStatus(false);
        setAlertMessage(getData?.data?.message);
        setShowAlert(true);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };
  const validateGuestRegister = () => {
    const guestNameValidation = guestNameValidationCheck();
    const contactNumberValidation = contactNumberValidationCheck();
    const categoryValidation = categoryValidationCheck();
    const emergencyNumberValidation = emergencyNumberValidationCheck();
    const visitPurposeValidation = visitPurposeValidationCheck();
    const locationValidation = locationValidationCheck();
    const companyValidation = companyValidationCheck();
    const vehicleValidation = vehicleValidationCheck();
    const fromPlaceValidation = fromPlaceValidationCheck();
    const visitorTypeValidation = visitorTypeValidationCheck();

    const guestListValidation = guestListValidationCheck();

    const idProofValidation = idProofValidatonCheck();

    const photovalidation = addPhotoValidationCheck();

    const magneticvalidation = magneticCardValidationCheck();

    if (
      guestNameValidation &&
      contactNumberValidation &&
      categoryValidation &&
      emergencyNumberValidation &&
      visitPurposeValidation &&
      locationValidation &&
      companyValidation &&
      vehicleValidation &&
      fromPlaceValidation &&
      visitorTypeValidation &&
      guestListValidation &&
      magneticvalidation &&
      photovalidation
    ) {
      if (isEdit) {
        callEditVisitorApi(visitorId);
      } else {
        callVisitorRegistration();
      }
    }
  };

  const providerValue = {
    guestType,
    setGuestType,
    showDropdown,
    setShowDropdown,
    magneticId,
    guestName,
    setGuestName,
    contactNo,
    setContactNo,
    category,
    setCategory,
    emergencyContactNo,
    setEmergencyContactNo,
    purposeOfVisit,
    setPurposeOfVisit,
    location,
    setLocation,
    magneticListData,
    magneticCardList,
    company,
    setCompany,
    vehicleNo,
    setVehicleNo,
    fromPlace,
    setFromPlace,
    visitorType,
    setVisitorType,
    visitorTypeDropdown,
    alertBack,
    setVisitorTypeDropdown,
    guestNameRequired,
    contactNoRequired,
    categoryRequired,
    emergencyContactNoRequired,
    purposeOfVisitRequired,
    locationRequired,
    companyRequired,
    vehicleNoRequired,
    fromPlaceRequired,
    visitorTypeRequired,
    validateGuestRegister,
    goBack,
    guestPhotoRequired,
    setGuestPhotoRequired,
    guestListRequired,
    setGuesListRequired,
    guestPhoto,
    setGuestPhoto,
    guestList,
    setGuestList,
    isCamera,
    setIsCamera,
    show,
    setShow,
    alertMessage,
    setAlertMessage,
    showAlert,
    setShowAlert,
    modalOpenStatus,
    setModalOpenStatus,
    categoryList,
    visitorTypeList,
    logout,
    magneticCardCode,
    displayName,
    VisitorName,
    isEdit,
    setMagneticId,
    assignedTo,
    setAssignedTo,
    idProof,
    setIdProof,
    inavalidIdProof,
    setInavalidIdProof,
    resetFields,
    photoLabel,
    pdfFileLabel,
    setPhotoLabel,
    setPdfFileLabel,
    setIndividual,
    setGuest,
    statusCode,
    changeable,
    magneticCardIdRequired,
    setMagneticCardIdRequired,
    idORPhotoOptional,
    setIdORPhotoOptional,
    cameraLabel,
    setCameraLabel,
    visitorSpinnerStatus,
  };

  return (
    <GuestRegisterContext.Provider value={providerValue}>
      {children}
    </GuestRegisterContext.Provider>
  );
};
